import { Component } from '@angular/core';

@Component({
  selector: 'app-site-role-template',
  template: `
    <span>
      {{ displayRole }}
    </span>
  `
})
export class SiteRoleTemplate {
  context: any;

  get displayRole(): string {
    console.log('FINAL CONTEXT => ', this.context);

    const role = this.context?.row?.obj?.entry?.role ?? this.context?.row?.obj?.role;

    console.log('ROLE => ', role);

    const ROLE_MAP: Record<string, string> = {
      SiteManager: 'Manager',
      SiteCollaborator: 'Collaborator',
      SiteContributor: 'Contributor',
      SiteConsumer: 'Consumer',
      SiteLead: 'Site Lead'
    };

    return ROLE_MAP[role] || role || 'Not a member';
  }
}
